// extracted by mini-css-extract-plugin
export default {"advertSearchLink":"_1vAcTDNn","advertSearchIcon":"CrPpAbJe"};